import { DateFormatKeys, DateFormats } from "./date-formats";

export class DayOfMonthLogic {
  static isDayValid(
    day: number,
    containingMonth: number | undefined,
    containingYear: number | undefined,
  ): boolean {
    if (day < 1 || day > 31) {
      return false;
    } else if (containingMonth && !isNaN(containingMonth)) {
      switch (containingMonth) {
        case 2:
          if (containingYear && !isNaN(containingYear)) {
            // Only years evenly divisible by 4 and NOT evenly divisible by 400 are leap years
            const isLeapYear: boolean =
              containingYear % 100 === 0
                ? containingYear % 400 === 0
                : containingYear % 4 === 0;

            if ((isLeapYear && day > 29) || (!isLeapYear && day > 28)) {
              return false;
            }
          } else if (day > 29) {
            return false;
          }
          return true;
        case 4:
        case 6:
        case 9:
        case 11:
          return day <= 30;

        default:
          return true;
      }
    }

    return true;
  }

  static isDayCompactlyFormatted(day: string): boolean {
    return DateFormats[DateFormatKeys.CompactDay].test(day);
  }

  static isDayLeadingZeroFormatted(day: string): boolean {
    return DateFormats[DateFormatKeys.TwoDigitLeadingZeroDay].test(day);
  }
}
